import { FM_DRAGAVATAR, isFreshman, startSpaceHelpers } from "helpers/freshman";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectFocusedHelper } from "slices/generalSlice";
import { selectInThisSpace } from "slices/sharedSelectors";
import {
  selectMeFocus,
  selectSpaceSideBar,
  selectSpaceBoxActive,
  selectSpaceSize,
} from "slices/spaceMediaSlice";
import {
  leaveSpace,
  selectSpaceFullScreen,
  selectSpaceLocked,
} from "slices/spaceSlice";
import { resetAllMedia } from "space/spaceMediaPhysics";
import { onWindowChangeSpace } from "space/spaceSetUp";
import DragAvatarHelper from "./DragAvatarHelper/DragAvatarHelper";
import SpaceTitle from "./SpaceTitle/SpaceTitle";

const Space = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const fullScreen = useSelector(selectSpaceFullScreen);
  const inThisSpace = useSelector(selectInThisSpace);
  const meFocus = useSelector(selectMeFocus);
  const spaceSideBar = useSelector(selectSpaceSideBar);
  const spaceSize = useSelector(selectSpaceSize);
  const spaceLocked = useSelector(selectSpaceLocked);
  const alive = useSelector(
    (state) => selectFocusedHelper(state) === FM_DRAGAVATAR
  );

  useEffect(() => {
    let timeout = null;
    if (spaceBoxActive) {
      document.getElementById("space").classList.add(`space-active`);
      // FOR FRESHMAN HELEPERS
      if (isFreshman()) {
        timeout = setTimeout(() => {
          startSpaceHelpers();
        }, 2000);
      }
    } else {
      document.getElementById("space").classList.remove("space-active");
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [spaceBoxActive]);

  useEffect(() => {
    if (inThisSpace && !fullScreen)
      document.getElementById("space-and-video").classList.add(`in-place`);
    else
      document.getElementById("space-and-video").classList.remove("in-place");
  }, [inThisSpace, fullScreen]);

  useEffect(() => {
    if (spaceLocked)
      document
        .getElementById("SPACEBOX")
        .querySelector(".doormat")
        .classList.add("locked");
    else
      document
        .getElementById("SPACEBOX")
        .querySelector(".doormat")
        .classList.remove("locked");
  }, [spaceLocked]);

  useEffect(() => {
    document.querySelector(".doorway").onclick = leaveSpace;
    return () => {
      document.querySelector(".doorway").onclick = null;
      document.getElementById("space").classList.remove("space-active");
    };
  }, []);

  useEffect(() => {
    let elem = document.getElementById("space");
    if (!elem) return;
    if (meFocus) elem.classList.add("focus-mode");
    else elem.classList.remove("focus-mode");
  }, [meFocus]);

  useEffect(() => {
    let elem = document.getElementById("space");
    if (!elem) return;
    if (spaceSideBar) elem.classList.add("side-bar-enlarged");
    else elem.classList.remove("side-bar-enlarged");
    onWindowChangeSpace();
  }, [spaceSideBar]);

  useEffect(() => {
    let elem = document.getElementById("space");
    if (!elem) return;
    elem.classList.remove("s1");
    elem.classList.remove("s2");
    elem.classList.remove("s3");
    elem.classList.remove("s4");
    elem.classList.add("s" + spaceSize);

    onWindowChangeSpace();
    resetAllMedia();
  }, [spaceSize]);

  if (spaceBoxActive)
    return (
      <>
        <SpaceTitle />
        {alive && <DragAvatarHelper />}
      </>
    );
  else return null;
};

export default Space;
